export interface ReservableRegulationInit {
  type: string;
  months: number;
  days: number;
  hours: number;
  minutes: number;
}

export default class ReservableRegulation {
  public readonly type: string;
  public readonly months: number;
  public readonly days: number;
  public readonly hours: number;
  public readonly minutes: number;

  constructor(init: ReservableRegulationInit) {
    this.type = init.type;
    this.months = init.months;
    this.days = init.days;
    this.hours = init.hours;
    this.minutes = init.minutes;
  }
}
